module.exports = __webpack_public_path__ + "static/media/startup.e6b9e3d5.webm";